/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React from "react";
import { cn } from "tailwind-variants";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import GangSheetBuilderContainer from "./GangSheetBuilderContainer.vue";
import { useDtfStore } from "./store";
import "./UploadBox.scss";

export default function UploadBox({ onUpload, ...restProps }: any) {
  const store = useDtfStore();

  // Computed properties
  function pdpType() {
    // @ts-expect-error TS(4111): Property 'pdpType' comes from an index signature, ... Remove this comment to see the full error message
    return store.pdpType;
  }

  function printAsIs() {
    // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
    return store.printAsIs;
  }

  function dtfTypeDropText() {
    // @ts-expect-error TS(4111): Property 'dtfTypeDropText' comes from an index sig... Remove this comment to see the full error message
    return store.dtfTypeDropText;
  }

  function businessLine() {
    // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
    return store.businessLine;
  }

  function showMultiSize() {
    // @ts-expect-error TS(4111): Property 'showMultiSize' comes from an index signa... Remove this comment to see the full error message
    return store.showMultiSize;
  }

  function isStandardArtwork() {
    // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
    return store.isStandardArtwork;
  }

  function showGangSheetBuilderFeature() {
    // @ts-expect-error TS(4111): Property 'showGangSheetBuilderFeature' comes from ... Remove this comment to see the full error message
    return store.showGangSheetBuilderFeature;
  }

  function userType() {
    // @ts-expect-error TS(4111): Property 'userType' comes from an index signature,... Remove this comment to see the full error message
    return store.userType;
  }

  function showModal() {
    // @ts-expect-error TS(4111): Property 'showModal' comes from an index signature... Remove this comment to see the full error message
    return store.showModal;
  }

  function showArtworkHistoryModal() {
    // @ts-expect-error TS(4111): Property 'showArtworkHistoryModal' comes from an i... Remove this comment to see the full error message
    return store.showArtworkHistoryModal;
  }

  function isUserSignedIn() {
    return userType() === "signed_in";
  }

  function isMultiUpload() {
    return showModal();
  }

  // Methods
  function setShowArtworkHistoryModal(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.setShowArtworkHistoryModal(...args);
  }

  function trackAddFileAreaClick() {
    submitDtfEvent("transfer_choose_file_clicked", {
      page: "pdp",
      pdp_type: pdpType(),
      business_line: businessLine()
    });
  }

  function handleUpload() {
    trackAddFileAreaClick();
    onUpload?.();
  }

  function onArtworkHistoryClick() {
    setShowArtworkHistoryModal(!showArtworkHistoryModal());
    submitDtfEvent("previous_purchase_link_clicked", {
      page: "pdp",
      pdp_type: pdpType()
    });
  }

  return (
    <div
      {...restProps}
      className={cn(
        "upload-box scope-e4c73329",
        restProps?.className,
        showMultiSize() && "upload-box--multi-size"
      )}
    >
      <div className="upload-box__title scope-e4c73329">More files to upload?</div>
      <div
        className={cn(
          "upload-box__wrapper scope-e4c73329",
          // @ts-expect-error TS migration
          isStandardArtwork() && "upload-box__wrapper--standard-artwork"
        )}
        onClick={handleUpload}
        data-testid="upload-box-wrapper"
      >
        <span className="upload-box__label-title hidden-xs scope-e4c73329">
          {/* @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'ReactNod... Remove this comment to see the full error message */}
          {dtfTypeDropText()}
        </span>
        {printAsIs() ? (
          <span className="upload-box__label-title visible-xs scope-e4c73329">
            {/* @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'ReactNod... Remove this comment to see the full error message */}
            {dtfTypeDropText()}
          </span>
        ) : (
          <span className="upload-box__label-title visible-xs scope-e4c73329">
            {" "}
            Tap anywhere to choose your images{" "}
          </span>
        )}
        <div className="upload-box__action-buttons scope-e4c73329">
          {showGangSheetBuilderFeature() ? (
            <GangSheetBuilderContainer
              className="scope-e4c73329"
              data-testid="gang-sheet-builder-container"
            />
          ) : null}
          <span
            className={cn(
              "upload-box__action scope-e4c73329",
              // @ts-expect-error TS migration
              isStandardArtwork() && "upload-box__action--standard-artwork"
            )}
          >
            {" "}
            Choose files{" "}
          </span>
        </div>
        {isUserSignedIn() && !isMultiUpload() ? (
          <a
            className="upload-box__dropzone-button scope-e4c73329"
            href="#"
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              onArtworkHistoryClick();
            }}
            data-testid="upload-box-dropzone-button"
          >
            {" "}
            My Design Library{" "}
          </a>
        ) : null}
      </div>
    </div>
  );
}
